// extracted by mini-css-extract-plugin
export default {"tooltip__line":"ElementTooltipComment_tooltip__line__ydEJL"};